import React from "react";
import "./Loading.scss";
class Loading extends React.PureComponent {
 
  constructor(props) {
    super(props)
  }
  componentDidMount() {
   
 
  }
  render() {
    return (
      <div className="loading">
        <div className='shadow'>
            <div className='dots'>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>
              <div>
              </div>

            </div>
            <p>加载中...</p>
                
          </div>
      </div>
    );
  }
}

export default Loading;
